import actionTypes from "../actionTypes";

export const FETCH_TRANSFERS = actionTypes("FETCH_TRANSFERS");
